// extracted by mini-css-extract-plugin
export default {"btnToggleWrapper":"YgI5B__btnToggleWrapper","activeBtn":"xNzCV__activeBtn"};